<template>
  <div id="menuItem">
    <nav>
      <el-menu :default-active="activeIndex" :router="true" class="el-menu-demo">
        <el-menu-item index="/">
          <span class="iconfont-el el-icon-house" style="vertical-align: 0px;"></span>
          {{ $t('home') }}
        </el-menu-item>
        <el-menu-item index="/collection/exhibitor">
          <span class="iconfont iconshoucang" style="vertical-align: 0px;"></span>
          {{ $t('myFavorite') }}
        </el-menu-item>
        <el-menu-item index="/footprint/exhibitor">
          <span class="el-icon-view" style="vertical-align: 0px;font-size: 14px;margin-right: 0px;"></span>
          {{ $t('watchHistory') }}
        </el-menu-item>
        <li class="el-menu-item el-menu-item_link" @click="goEzt3Login">
          <span class="iconfont-el el-icon-edit-outline"></span>
          <span>Pre-registration</span>
        </li>
        <!-- 采购对接会 -->
        <!-- <el-menu-item index="/procurementDocking">
          <span class="iconfont-el el-icon-coin"></span>
          <span class="f-w-b">{{ $t('procurementDocking') }}</span>
        </el-menu-item> -->
        <!-- 公司管理 -->
        <!-- <el-menu-item
            v-if="!noAdmin && subjectType == 'ACTOR'"
            index="/company-management">
            <span class="iconfont iconshow_gongsiguanli1"></span>
            {{ $t('companyManage') }}</el-menu-item> -->
        <!-- 展品管理 -->
        <!-- <el-menu-item index="/my-exhibit-list" v-if="subjectType === 'ACTOR'">
           <span class="iconfont-el el-icon-coin"></span>
          {{ $t('exhibitsManage') }}
        </el-menu-item> -->
        <!-- 员工管理 -->
        <!-- <el-menu-item index="/my-employee-list" v-if="!noAdmin && subjectType == 'ACTOR'">
          <span class="iconfont iconguanzhong_weixuanzhong"></span>
          {{ $t('finds.employeeeManage') }}
        </el-menu-item> -->
        <!-- 问卷管理 -->
        <!-- <el-menu-item index="/personal/questionnaire/change"
            v-if="!noAdmin && subjectType == 'ACTOR' && false">
            <span class="iconfont iconicon_huabanfuben"></span>
            {{$t('Survey Management')}}</el-menu-item> -->
        <!-- 数据报表 -->
        <!-- <el-menu-item v-if="false" :index="subjectType == 'ACTOR' ? '/report/actorIndex' : '/report/personReport'">
          <span class="iconfont-el el-icon-data-line" style="vertical-align: 0px;"></span>
          {{$t('actorIndex')}}
        </el-menu-item> -->
        <!-- 个人中心 -->
        <!-- (subjectType === 'ACTOR' && !$config.settings.noActor2 ) ||  -->
        <!--入场凭证-->
        <!-- <el-submenu index="1">
          <template slot="title"><span class="iconfont iconwode_weixuanzhong"></span>{{ $t('profile') }}</template>
          <el-menu-item :index="'/companyfile'" v-if="subjectType=='VISITOR' && config.visitorSecondRegister">{{
            $t('login2s.companyInfo') }}</el-menu-item>
          <el-menu-item :index="'/personal/change-password'">{{$t('finds.changePass')}}</el-menu-item>
          <el-menu-item v-if="(subjectType=='VISITOR' && !$config.settings.onlayReg2) || subjectType === 'ACTOR'"
            :index="subjectType === 'ACTOR' ? '/footprint/person' : '/footprint/exhibitor'">{{ $t('watchHistory')
            }}</el-menu-item>
          <el-menu-item v-if="(subjectType=='VISITOR' && !$config.settings.onlayReg2) || subjectType === 'ACTOR'"
            :index="subjectType === 'ACTOR' ? '/collection/audience' : '/collection/exhibitor'">{{ $t('myFavorite')
            }}</el-menu-item>

          <el-menu-item v-if="(subjectType=='VISITOR' && !$config.settings.onlayReg2 && true) && false"
            :index="'/voucher'">{{ $t('gPreReg.voucher') }}</el-menu-item>
        </el-submenu> -->
        <!-- 消息中心 -->
        <!-- <el-submenu index="2" 
          v-if="(subjectType === 'ACTOR') || (subjectType === 'VISITOR' && !$config.settings.onlayReg2)" 
          :class="{ 'has-new-msg': newMessageComing || newMailComing }">
          <template slot="title">
            <span class="iconfont-el iconfont iconxiaoxi_weixuanzhong"></span>
            <span class="font-size-16">{{ $t('notification') }}</span>
          </template>
          <el-menu-item @click="openChatDialog()">
              <el-badge
                  :is-dot="newMessageComing"
                  class="item"
              >{{ $t('Send message') }}
              </el-badge>
          </el-menu-item>
          <el-menu-item index="/mail">
            <el-badge :is-dot="newMailComing" class="item">{{ $t('Message management') }}</el-badge>
          </el-menu-item>
        </el-submenu> -->
        <!-- 在线客服 -->
        <!-- <el-submenu
          index="3"
          v-if="customerServiceInfo"
        >
          <template slot="title">
            <span class="iconfont iconshow_dianhua"></span>
            <span class="f-w-b">{{ $t('Online Service') }}</span>
          </template>
          <li
            class="el-menu-item el-menu-item_link"
            @click="customerService(onlineServices)"
          >
            <span class="external_link" >
              {{ language === 'en' ? customerServiceInfo.enName : customerServiceInfo.name }}
            </span>
          </li>
        </el-submenu> -->
        <!-- 邀约管理 -->
        <!-- <el-menu-item index="/invite"
          v-if="(subjectType === 'ACTOR') || (subjectType === 'VISITOR' && !$config.settings.onlayReg2)">
          <span class="iconfont iconyaoyue"></span>
          {{ $t('invitationManagement') }}
        </el-menu-item> -->
        <!-- 意向订单 -->
        <!-- <el-menu-item
             v-if="(subjectType === 'ACTOR') || (subjectType === 'VISITOR' && !$config.settings.onlayReg2)"
            index="/potential-order">
            <template slot="title">
            <span class="iconfont icon91act_guanliyixiangdingdan"></span>
            {{$t('order.Potential Order Management')}}
          </template>
        </el-menu-item> -->
        <!-- 热点图管理 -->
        <!-- <el-menu-item index="/hotspot" v-if="subjectType === 'ACTOR' && info && info.exhibitorEmployee && info.exhibitorEmployee.exhibitor.hotImage && false">
           <span class="iconfont-el el-icon-coin"></span>
          {{ $t('Hot Showcase') }}
        </el-menu-item> -->
        <!-- 直播管理 -->
        <!-- <el-menu-item index="/liveManage" v-if="subjectType == 'ACTOR' && false">
            <span class="iconfont-el el-icon-video-camera"></span>
            {{$t('lives["Live Management"]')}}</el-menu-item> -->
        <!-- 商机管理/商脉圈 marketing -->
        <!-- <el-submenu index="7"
          v-if="subjectType == 'ACTOR' || (subjectType == 'VISITOR' && !$config.settings.onlayReg2)">
          <template slot="title">
            <span class="iconfont iconshangmaiquan"></span>
            {{ $t('finds.businessCircle') }}
          </template>
          <el-menu-item index="/opportunity-manage/list">{{$t('my_releases')}}</el-menu-item>
          <el-menu-item index="/opportunity-manage/publish">{{$t('release_requirements')}}</el-menu-item>
        </el-submenu> -->
        <!-- 更新日志-->
        <!-- <el-menu-item index="/versionLog" v-if="(subjectType === 'ACTOR' && !$config.settings.noActor2) || (subjectType === 'VISITOR' && !$config.settings.onlayReg2)">
          <span class="iconfont icontime"></span>
          {{ $t('common.versionLog') }}
        </el-menu-item> -->
        <!-- 邀请码 -->
        <!-- <el-menu-item index="/invitationCode" v-if="subjectType === 'ACTOR'">
          <span class="iconfont icon95show_yaoqingma"></span>
           {{ $t('invitationCode') }}
        </el-menu-item> -->
        <!-- 邀请函记录-->
        <!-- <el-menu-item index="/invitehistory" v-if="!$config.settings.noActor2 && subjectType === 'ACTOR'">
          <span class="iconfont icon94show_yaoqinghan"></span>
          {{ $t('clientPool.exhibitor_invitation_record') }}
        </el-menu-item> -->
        <!-- 邀请函-->
        <!-- <li class="el-menu-item el-menu-item_link" v-if="subjectType === 'ACTOR' && iHref && !$config.settings.noActor2">
          <span class="iconfont-el el-icon-message"></span>
          <a target="_blank" class="external_link" :href="iHref">{{ $t('common.invitation') }}</a>
        </li> -->
        <!-- 邀请函记录-->
        <!-- 邀请函-->
        <!-- <el-submenu index="8" v-if="subjectType == 'ACTOR'">
          <template slot="title">
            <span class="iconfont-el el-icon-message"></span>
            <span>{{ $t('mentInvitation') }}</span>
          </template>
          <el-menu-item index="/invitehistory" v-if="subjectType === 'ACTOR'">
            <span>{{ $t('clientPool.exhibitor_invitation_record') }}</span>
          </el-menu-item>
          <el-menu-item index="/inviteSend" v-if="subjectType === 'ACTOR'">
            <span>{{ $t('common.invitation') }}</span>
          </el-menu-item>
        </el-submenu> -->
        <!-- 帮助手册-->
        <!-- <li class="el-menu-item el-menu-item_link" v-if="subjectType === 'ACTOR' && $config.handBook && false">
          <span class="iconfont icontop_zhanshangshouce"></span>
          <a class="external_link" download v-if="language == 'en'" :href="$config.handBook_en" target="view_window">{{
            $t('common.Handbook') }}</a>
          <a class="external_link" download v-else :href="$config.handBook" target="view_window">{{
            $t('common.Handbook') }}</a>
        </li> -->
        <!-- 客商版 帮助手册 -->
        <!-- <li class="el-menu-item el-menu-item_link"
          v-if="subjectType == 'VISITOR' && !$config.settings.onlayReg2  && $config.v_handBook_cn && false">
          <span class="iconfont icontop_zhanshangshouce"></span>
          <a class="external_link" target="view_window" v-if="language == 'zh' && $config.v_handBook_cn"
            :href="$config.v_handBook_cn">{{ $t('common.Handbook') }}</a>
          <a class="external_link" target="view_window" v-if="language == 'en' && $config.v_handBook_en"
            :href="$config.v_handBook_en">{{ $t('common.Handbook') }}</a>
        </li> -->
        <!-- 展商版 展商调研 -->
        <!-- <li class="el-menu-item el-menu-item_link" v-if="subjectType === 'ACTOR' && !$config.settings.noActor2">
          <span class="iconfont-el el-icon-edit-outline"></span>
          <a
            class="external_link"
            target="_blank"
            :href="language == 'en' ? $config.exhibitorResearch_en : $config.exhibitorResearch"
          >{{ $t('common.exhibitorResearch') }}</a>
        </li> -->
      </el-menu>
    </nav>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import { getAuthCode } from '@/api/index'

export default {
  name: 'menuItem',
  components: {},
  data() {
    return {
      activeIndex: ''
    }
  },
  computed: {
    ...mapState([
      'onlineServices',
      'onlineServiceTel'
    ]),
    ...mapState({
      newMessageComing: state => state.timStore.newMessageComing,
      newMailComing: state => state.timStore.newMailComing,
    }),
    ...mapGetters([
      'currentUserProfile',
      'conversationList',
      'isTIM',
      'language',
      'name',
      'isLogin',
      'info',
      'subjectType',
      'exhibitionId',
      'exhibitorId',
      'config'
    ]),
    noAdmin() {
      return (
        !this.info || (this.info && !this.info.exhibitorEmployee) || (this.info && this.info.exhibitorEmployee && !this.info.exhibitorEmployee.admin)
      )
    },
    ...{
      iHref() {
        return (this.$config.invitation && this.info && this.info.userAccountId) ? (this.$config.invitation + this.exhibitorId + '&exhibitionId=' + this.exhibitionId + "&userAccountId=" + this.info.userAccountId) : ''
      }
    }
  },
  watch: {
    $route: function() {
      this.menuActive()
    }
  },
  // TODO 
  // mounted() {
  //   if (this.onlineServices.length === 0 && this.isLogin) {
  //     allocationCustomerService({}).then(res => {
  //       this.$store.commit('setOnlineServices', res.data.data)
  //     })
  //     getFetchList({})
  //       .then(res => {
  //         return res.data
  //       })
  //       .then(res => {
  //         if (res.data) {
  //           res.data.config && this.$store.commit('setOnlineServiceTel', res.data.config.customServiceTelephone)
  //         }
  //       })
  //   }

  //   this.$nextTick(() => {
  //     this.menuActive()
  //   })
  // },
  mounted() {
    this.$nextTick(() => {
      this.menuActive()
    })
  },
  methods: {
    // 跳转ezt3
    async goEzt3Login() {
      const authData = await getAuthCode()
      const data = authData.data
      if (data.code === 1000) {
        const authCode = data.data
        // 正式环境
        const target = `https://regcn.cacshow.com/#/jump?exhibitionId=1823536898857046018&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1823539766322335746&isOpenAdapt=yes&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`

        // const target = `http://172.16.1.252:5173/#/jump?exhibitionId=1823536898857046018&registerType=visitor&languageType=en&registrationSource=registration&tenantId=941505&registerLinkId=1823539766322335746&isOpenAdapt=yes&from=pcIzt&fromUrl=${location.origin}&imasterCode=${authCode}`
        
        window.location.href = target
      }
    },
    // 打开聊天
    async openChatDialog() {

    },
    // goProductCollection() {
    //   queryProductCollection({})
    //     .then(res => {
    //       return res.data
    //     })
    //     .then(res => {
    //       if (res.data) {
    //         window.location.href = res.data
    //       }
    //     })
    // },
    // 点击菜单选中
    menuActive: function() {
      let path = this.$route.path
      if (this.$route.meta && this.$route.meta.pPath) {
        if (typeof this.$route.meta.pPath === 'string') {
          path = this.$route.meta.pPath
        } else {
          path = this.$route.meta.pPath[this.subjectType]
        }
      }
      this.activeIndex = path
      if(this.$route.path.indexOf('hotspot-detail') !== -1) {
        this.activeIndex = '/hotspot'
      }
    },
    toVersionLog() {
      this.$router.push('/versionLog');
    }
  }
}
</script>
<style lang="stylus">
#menuItem {
  width: 200px;
  position: fixed;
  top: 68px;
  left: 50%;
  margin-top: 30px;
  margin-left: calc(-1336px / 2);
  max-height: calc(100% - 98px - 30px);
  overflow: hidden;
  overflow-y: auto;
  z-index 100;

  .el-menu {
    border-right: none;
  }

  .external_link {
    color: $color-black-85;
  }
  .external_link:hover{ 
    color: $color-main;
  }

  .el-menu-item_link:hover{ 
    .external_link{ 
      color: $color-main;
    }
  }

  .el-menu-item, .el-submenu__title {
    height: 44px !important;
    line-height: 44px !important;
    min-width: 200px !important;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding 0 3px  !important;
  }
  .el-menu--inline{
    .el-menu-item{
      padding-left: 34px !important;
    }
  }
  
  .el-menu-item:hover, .el-menu-item:focus, .el-submenu__title:hover, .el-submenu__title:focus {
    position: relative;
    background-color: transparent;
    color: $color-main;
  }

  .el-menu-item.is-active {
    background-color: $color-main !important;
    color: $color-white !important;
  }
  .has-new-msg:after{
    content :''
    width 7px
    height 7px
    position absolute
    top: 8px;
    left : 14%;
    border-radius 50%
    background-color $color-red-f5
  }
  .has-new-msg{
    position relative
  }

  &.grayBackground {
    .el-menu{
      background $color-gray-fb
    }
  }

  .iconfont-el {
    font-size: 14px;
    margin: 9px 8px;
    width: auto;
  }

}

@media screen and (max-width: 1366px) {
    #menuItem {
      left: 0;
      margin-left: 15px;
    }

    .version .calendar-view {
      left: 0!important;
      margin-left: 230px!important;
    }
}
</style>
